import { render, staticRenderFns } from "./ShapePage.vue?vue&type=template&id=6e8c3412&"
import script from "./ShapePage.vue?vue&type=script&lang=js&"
export * from "./ShapePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports